import { render, staticRenderFns } from "./CategoryItem.vue?vue&type=template&id=d6a2fdc8&scoped=true&"
import script from "./CategoryItem.vue?vue&type=script&lang=js&"
export * from "./CategoryItem.vue?vue&type=script&lang=js&"
import style0 from "./CategoryItem.vue?vue&type=style&index=0&id=d6a2fdc8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a2fdc8",
  null
  
)

export default component.exports